import * as angular from 'angular';
import * as _ from 'lodash';

import { IApprovalSettingsService } from '../../services';
import { ApprovalSettings } from '../../models';
import { Store } from '../Store';
import * as APPROVALSETTINGS from './approvalSettings.constants';

import {
    loadApprovalSettings,
    loadApprovalSettingsSuccess,
    updateApprovalSettings,
    updateApprovalSettingsSuccess
} from './approvalSettings.actions';


export interface IApprovalSettingActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    addOne(target: ApprovalSettings): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    // addMany(targets: ApprovalSettings[]): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    updateOne(target: ApprovalSettings): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    // updateMany(targets: ApprovalSettings[]): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    // deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
    // deleteMany(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<ApprovalSettings[]>;
}

export class ApprovalSettingsActionsService implements IApprovalSettingActionsService {

    static serviceId = 'approvalSettingsActionsService';
    static $inject = ['$q', 'approvalSettingsService'];


    constructor(private _$q: angular.IQService,
        private _approvalSettingService: IApprovalSettingsService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalSettings } = getState();
            if (!approvalSettings.isLoading && !approvalSettings.isLoaded) {
                dispatch(loadApprovalSettings());
                return this._approvalSettingService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadApprovalSettingsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<ApprovalSettings>(approvalSettings.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalSettings } = getState();
            if (force || (!approvalSettings.isLoading && !approvalSettings.isLoaded)) {
                dispatch(loadApprovalSettings());
                return this._approvalSettingService.getAll(force)
                    .then(data => {
                        dispatch(loadApprovalSettingsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ApprovalSettings>(approvalSettings.dictionary));
            }
        };
    }

    addOne(target: ApprovalSettings) {
        return this.updateOne(target);
    }

    // addMany(targets: ApprovalSettings[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalSettings } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(addApprovalSettings(targets));
    //             return this._approvalSettingService.addApprovalSettings(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(addApprovalSettingsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_ADD_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ApprovalSettings>(approvalSettings.dictionary));
    //         }
    //     };
    // }

    updateOne(target: ApprovalSettings) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalSettings } = getState();
            if (target) {
                dispatch(updateApprovalSettings([target]));
                return this._approvalSettingService.update(target.guid, target)
                    .then(data => {
                        const result = data;
                        dispatch(updateApprovalSettingsSuccess([result]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ApprovalSettings>(approvalSettings.dictionary));
            }
        };
    }

    // updateMany(targets: ApprovalSettings[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalSettings } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(updateApprovalSettings(targets));
    //             return this._approvalSettingService.updateApprovalSettings(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(updateApprovalSettingsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ApprovalSettings>(approvalSettings.dictionary));
    //         }
    //     };
    // }

    // deleteOne(guid: string) {
    //     return this.deleteMany([guid]);
    // }

    // deleteMany(guids: string[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalSettings } = getState();
    //         if (guids && guids.length > 0) {
    //             dispatch(deleteApprovalSettings(guids));
    //             return this._approvalSettingService.deleteApprovalSettings(guids)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(deleteApprovalSettingsSuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<ApprovalSettings>(approvalSettings.dictionary));
    //         }
    //     };
    // }
}